module.exports = __webpack_public_path__ + "20250721160708/img/my_site.580f99fd.png";